<template>
  <div></div>
</template>

<script>
export default {
  name: "SLAAgreement"
};
</script>
